<div class=" border-t border-gray-300 mx-auto w-3/4"></div>
<section class="bg-white py-16 mt-16">
  <div class="container mx-auto px-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <div class="max-w-sm mx-auto rounded-lg overflow-hidden shadow-lg bg-white">
        <img class="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1648326342761-8a9abfb7a2c0?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Habitaciones ecológicas">
        <div class="p-6">
          <div class="font-bold text-xl mb-2">Habitaciones ecológicas</div>
          <p class="text-gray-700 text-base">
            Disfruta de la comodidad en habitaciones sostenibles, diseñadas para tu descanso y el respeto por la naturaleza.
          </p>
        </div>
      </div>

      <div class="max-w-sm mx-auto rounded-lg overflow-hidden shadow-lg bg-white">
        <img class="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1682687982468-4584ff11f88a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Experiencias únicas">
        <div class="p-6">
          <div class="font-bold text-xl mb-2">Experiencias únicas</div>
          <p class="text-gray-700 text-base">
            Senderismo, avistamiento de aves, paseos en kayak y mucho más. Conéctate con la naturaleza como nunca antes.
          </p>
        </div>
      </div>

      <div class="max-w-sm mx-auto rounded-lg overflow-hidden shadow-lg bg-white">
        <img class="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Compromiso sostenible">
        <div class="p-6">
          <div class="font-bold text-xl mb-2">Compromiso sostenible</div>
          <p class="text-gray-700 text-base">
            Implementamos energía renovable, reciclaje y conservación de la biodiversidad para un turismo responsable.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

